import { useIntl } from 'react-intl';
import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { spacingVars } from '@astryxdesign/core/theme/tokens.stylex';
import { Heading } from '@astryxdesign/core/Heading';
import { sectionPermissions } from '@qronstat/shared';
import { useApp } from '../app/context';
import { useSavedItems } from '../api/saved';
import { ReportView } from '../reports/ReportView';
import { reportDefinition } from '../reports/types';
export function PinnedReports() {
  const intl = useIntl();
  const {
    can
  } = useApp();
  const allowed = can(sectionPermissions.reports);
  const pinned = useSavedItems({
    kind: 'report',
    pinned: true
  }, allowed);
  const items = (pinned.data?.items ?? []).filter(i => i.pinned);
  if (!allowed || !items.length) return null;
  return <section className="x78zum5 xdt5ytf x18g69wz x1pzlopt x1awphl8" aria-label={intl.formatMessage({
    id: 'reports.pinned'
  })}>
      <Heading level={3}>{intl.formatMessage({
        id: 'reports.pinned'
      })}</Heading>
      {items.map(item => {
      const parsed = reportDefinition.safeParse(item.definition);
      if (!parsed.success) return null;
      return <ReportView key={item.id} id={item.id} definition={parsed.data} title={item.name} />;
    })}
    </section>;
}